import { Component, OnInit } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ArticalManagementService } from '../artical-management/artical-management.service';
import { ArticalsService } from './articals.service';

@Component({
  selector: 'app-articals',
  templateUrl: './articals.component.html',
  styleUrls: ['./articals.component.scss']
})
export class ArticalsComponent implements OnInit {
  allArticals = [];
  page = 1;
  pageSize = 12;
  collectionSize: number;
  rows: any[];
  selectedType: number = 0;
  type;

  constructor(
    private articalsService: ArticalsService,
    private articalManagementService: ArticalManagementService,
    private gobalFunctionService: GobalFunctionService

  ) { }

  ngOnInit(): void {
    this.articalManagementService.getCategoryArtical().pipe(
      switchMap(type => {
        this.type = type.result
        return this.articalsService.getAllArticalByType(this.selectedType)
      }),
      map(artical => {
        this.allArticals = artical.result;
        this.refresh();
        this.gobalFunctionService.setSEO('บทความทั้งหมด', 'website', '');
      })
    ).subscribe();
  }

  changeType() {
    this.articalsService.getAllArticalByType(this.selectedType).subscribe(res => {
      this.allArticals = res.result;
      this.refresh();
    })
  }

  refresh() {
    this.collectionSize = this.allArticals.length;
    this.rows = this.allArticals
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }
}
